import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessoriesModalService {

  private selectedAccessorySubject = new BehaviorSubject<any>(null);
  public selectedAccessory$ = this.selectedAccessorySubject.asObservable();

  constructor() { }

  setSelectedAccessory(accessory: any): void {
    this.selectedAccessorySubject.next(accessory);
  }

  getSelectedAccessory(): any | null {
    return this.selectedAccessorySubject.value;
  }

  clearSelectedAccessory(): void {
    this.selectedAccessorySubject.next(null);
  }
}
